import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import User from '../../models/User';

/**
 * Текущий раут.
 */

const initialState: User = {
 fullName: 'Петров Гарик Гарикович',
 shortName: 'Петров Г.Г.',
 firstName: 'Гарик',
 middleName: 'Гарикович',
 lastName: 'Петров',
 email: 'ACHernuckij@vostok-electra.ru',
 account: 'ACHernuckij@corp.vostok-electra.ru',
 accountNumber: '1122334455',
 phone: '+7 912 039-40-00',
};

export const getUserSlice = createSlice({
 name: 'getUserSlice',
 initialState,
 reducers: {
  getUserData: (state, action: PayloadAction<User>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { getUserData } = getUserSlice.actions;

export default getUserSlice.reducer;
